export function toFloatOrUndefined(rawNumber: string | null): number | undefined {
  if (!rawNumber) return undefined;
  const parsed = Number.parseFloat(rawNumber);
  return Number.isNaN(parsed) ? undefined : parsed;
}
